import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {}

const DotTable: React.FC<IProps> = (props) => {
	return (
		<svg
			width="405"
			height="154"
			viewBox="0 0 405 154"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle cx="212.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="212.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="233.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="254.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="275.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="296.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="317.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="338.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="359.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="380.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="401.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="3.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="24.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="45.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="66.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="87.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="108.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="129.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="150.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="171.5" cy="150.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="3.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="24.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="45.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="66.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="87.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="108.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="129.5" r="3.5" fill="currentColor" />
			<circle cx="192.5" cy="150.5" r="3.5" fill="currentColor" />
		</svg>
	);
};

export default memo(DotTable);
